import React from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";

export default function StatusTag({
  title,
  icon,
  onClick,
  display = "danger"
}) {
  return (
    <span
      className={`label label-${display}`}
      role={onClick && "button"}
      onClick={onClick}
    >
      <Icon name={icon} />
      &nbsp;&nbsp;{title}
    </span>
  );
}

StatusTag.propTypes = {
  title: T.string.isRequired,
  icon: T.string.isRequired,
  onClick: T.func,
  display: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatusTags/StatusTag.jsx